import GetIcon from '../../../../utils/Icon';
import { useState } from 'react';
import VersionHistory from '../../../../utils/VersionHistory';
import Input from '../../../../Core/Fields/Floating/Input';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
const Tab1 = ({ vendor, po, activityboll, fulldata }) => {
  console.log(vendor.vendor, "");
  const [showActivity, setShowActivity] = useState(true);
  return (
    <div
      className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px", height: '72vh', overflowY: 'scroll', flexWrap: 'nowrap' }}
    >
      <div className="col-12 mb-2 ">



        <Input id="termsandconditions" label="GRN No." readOnly value={po.current_op} style={{ height: '30px' }} />
      </div>

      <div className="col-12 mb-2 ">


        <Input id="termsandconditions" label="Purchase Order No." readOnly value={fulldata?.message?.items[0]?.purchase_order} style={{ height: '30px' }} />
      </div>

      <div className="col-12 mb-2 ">

        <Input id="termsandconditions" label="Supplier" readOnly value={vendor.vendor} style={{ height: '30px' }} />
      </div>
      <div className="col-12 mb-2">

        <Input id="termsandconditions" label="Post Date" readOnly value={fulldata?.message?.posting_date} style={{ height: '30px' }} />
      </div>
      <div className="col-12 ">

        <Input id="termsandconditions" label="Post Time" readOnly value={fulldata?.message?.posting_time} style={{ height: '30px' }} />
      </div>

      <CollapsibleSection title="Accounting Dimensions">
        <div className="col-lg-12 mt-3 mb-3" >
          <Input id="termsandconditions" label="Cost Center" value={fulldata.message?.cost_center} readOnly style={{ height: '30px' }} />

        </div>
        <div className="col-lg-12 mt-3 mb-3" >
          <div className={`mb-3`}>


            <Input id="termsandconditions" label="Project" value={fulldata.message?.project} readOnly style={{ height: '30px' }} />

          </div>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Currency and Price List">
        <div className="col-lg-12 mt-3 mb-3" >
          <div className={`mb-3`}>
            <Input id="termsandconditions" label="Currency" readOnly value={fulldata.message?.currency} style={{ height: '30px' }} />

          </div>
        </div>

        <div className="col-lg-12 mt-3 mb-3" >
          <div className={`mb-3`}>
            <Input id="termsandconditions" label="Price List" value={fulldata.message?.buying_price_list} readOnly style={{ height: '30px' }} />

          </div>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Taxes and Charges">
        <div className="col-lg-12 mt-3 mb-3" >
          <div className={`mb-3`}>
            <Input id="termsandconditions" label="Taxes and Charges" value={fulldata.message?.taxes_and_charges} readOnly style={{ height: '30px' }} />

          </div>
        </div>
      </CollapsibleSection>

      {/* <CollapsibleSection title="Payment Terms">
               <div className="col-lg-12 mt-3 mb-3" >
                 <div className={`mb-3`}>
             <Input id="termsandconditions" label="Payment Terms Template" value={fulldata.message?.payment_terms_template} readOnly style={{ height: '30px' }} />
     
               </div>
               </div>
               
             </CollapsibleSection> */}

      <CollapsibleSection title="Terms & Conditions">

        <div className="col-lg-12 mt-1 mb-3" >
          <div className={`mb-3`}>
            <Input id="termsandconditions" label="Terms and Conditions" value={fulldata.message?.tc_name} readOnly style={{ height: '30px' }} />

          </div>
        </div>

      </CollapsibleSection>


      <div >
        <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0" >
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>
          {showActivity && (
            <VersionHistory doctype="Purchase Receipt" docname={po.current_op} activityboll={activityboll} />

          )}
        </div>
      </div>

    </div>
  )
}

export default Tab1